const LoadingFallback = () => (
    <div className="flex items-center justify-center h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#2E6C83]"></div>
    </div>
  );
  
  export default LoadingFallback;
  